import { render, staticRenderFns } from "./CargaCicloSemestre.vue?vue&type=template&id=95d8d280&"
import script from "./CargaCicloSemestre.vue?vue&type=script&lang=js&"
export * from "./CargaCicloSemestre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports